import { Component, OnInit } from '@angular/core';
import { SecureComponent } from './secure/secure.component';
import { Router } from '@angular/router';
import { AppServiceManager } from '../common/services/appServiceManager';
import { MenuItem, MessageService } from 'primeng/api';
import { DataService } from './shared/data.service';
import { IUser } from './shared/Domains/IUser';
import { ICompany } from './shared/Domains/company';
import { Configuration } from 'config/config';
import { IRole } from "app/shared/Domains/role";
import { AuthService } from 'common/services/auth.service';
import { DatePipe } from '@angular/common';
import { VisitorDialogueComponent } from 'app/VisitorManagement/IndependentVisitor/visitordialouge.component';
import { PettyCashDialougeComponent } from './IndependentPettyCash/pettycashdialouge.component';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: 'app-topbar',
    templateUrl:'./app.topbar.component.html'
})

export class AppTopbarComponent implements OnInit {
    notifyArray: any;
    loading: boolean;
    branchName:string;
    notifyTrainerArray: any;
    company: ICompany;
    user: IUser;
    branch: string;
    visitorDialog: boolean;
    pettyCashDialog: boolean;
    pettyLendingDialog: boolean;
    items: MenuItem[] | undefined;
    hasPettyCashAccount = false;
    licencestate: string;
    role: IRole;
    license: any;
    licenseMessage: string = "License is valid till Friday, May 30, 2025 (381 days remaining)";
    menuButton: boolean = true;
    menuStateOpen = true;
    selectedlanguage: any;
    bannerImage: any;
    gymPackage: any;
    showLiveAttendance = false;
    constructor(
      private LanguageService: LanguageService,
        private dataService: DataService,
        private datePipe: DatePipe,
        private route: Router,
        public config: Configuration,
        public app: SecureComponent,
        private appServiceManager: AppServiceManager,
        private messageService: MessageService,) {
        this.company = AuthService.getLoggedInCompanyBranch();
        this.branch = AuthService.getLoggedInBranch();
    }
    ngOnInit() {
      this.notifyArray = 0;
      this.loading = false;
      this.user = AuthService.getLoggedInUser();
      this.role = AuthService.getLoggedInRole();
      if (this.user.hasPettyCashAccount) {
        this.hasPettyCashAccount = true;
      }
      this.showLiveAttendance =
        !!AuthService.getLoggedInCurrentBranch()?.permissions?.liveAttendanceScreen;
      this.getBranchById();
      this.notifyTrainerArray = 0;
      this.licencestate = "success";
      this.dataService.currentLength.subscribe(length => this.notifyArray = length);
      this.dataService.currentTrainerLength.subscribe(trianerLength => this.notifyTrainerArray = trianerLength);
      this.selectedlanguage = localStorage.getItem('Lang');
      if(!this.selectedlanguage){
        this.selectedlanguage = 'en';
      }
        this.licenceExpire();
        this.items = [
          {
              label: 'Quick Access',
              items: [
                  {
                      label: this.setLabel("addPettyCashLabel"),
                      icon: 'pi pi-plus',
                      command: (e) => this.openPettyCashDialogue()
                  },
                  {
                      label: this.setLabel("pettyLendingLabel"),
                      icon: 'pi pi-plus',
                      command: (e) => this.openPettyLendingDialog()
                  }
              ]
          }
      ];
    }

    /**
     * Checks if user has Member Management privilege
     * @returns true if user has Member Management privilege, false otherwise
     */
    hasMemberManagementPrivilege(): boolean {
      if (!this.role || !this.role.privileges || this.role.privileges.length === 0) {
        return false;
      }
      return this.role.privileges.some(permission => permission.pageType === "Member Management");
    }

    /**
     * Checks if user has Petty Cash privilege
     * @returns true if user has Petty Cash privilege, false otherwise
     */
    hasPettyCashPrivilege(): boolean {
      if (!this.role || !this.role.privileges || this.role.privileges.length === 0) {
        return false;
      }
      return this.role.privileges.some(permission => permission.pageType === "Petty Cash");
    }
    onMenuClickState(){
      this.menuStateOpen = !this.menuStateOpen
    }
    setLabel(label) {
      return this.LanguageService.GetCurrentLanguage("AppTopbarComponent", label);
    }
    getBranchById() {
        this.loading = true;
        this.appServiceManager.get('branches/'+ AuthService.getLoggedInBranch()).subscribe((res) => {
          if (res) {
            this.branchName = res.name;
            this.gymPackage = res.gymPackage;
            this.bannerImage = res.companyDetails.bannerImage.image;
            this.showLiveAttendance = !!res.permissions?.liveAttendanceScreen;
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Records Found' });
          }
          this.loading = false;
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    logout() {
        localStorage.clear();
        this.route.navigateByUrl('/login');
    }

    /**
     * Opens (or focuses) the live attendance screen in a dedicated popup window.
     * A named target reuses the same window on repeat clicks. Window features
     * (third argument) ask the browser for a separate window rather than a tab.
     * HashLocationStrategy requires the '#/' prefix.
     */
    openLiveAttendance() {
        const url =
            window.location.origin +
            window.location.pathname +
            '#/live-attendance';

        const width = window.screen.availWidth;
        const height = window.screen.availHeight;
        const left = window.screenLeft ?? window.screenX ?? 0;
        const top = window.screenTop ?? window.screenY ?? 0;

        const features = [
            `width=${width}`,
            `height=${height}`,
            `left=${left}`,
            `top=${top}`,
            'menubar=no',
            'toolbar=no',
            'location=no',
            'status=no',
            'scrollbars=yes',
            'resizable=yes',
        ].join(',');

        const win = window.open(url, 'tecgymLiveAttendance', features);
        win?.focus();
    }

    openVisitorDialogue(){
        this.visitorDialog=true;
      }

      closeVisitorDialog() {
        this.visitorDialog = !this.visitorDialog;
      }

      openPettyCashDialogue(){
        this.pettyCashDialog=true;
      }

      closePettyCashDialog() {
        this.pettyCashDialog = !this.pettyCashDialog;
      }
     openPettyLendingDialog(){
        this.pettyLendingDialog=true;
      }

      closePettyLendingDialog() {
        this.pettyLendingDialog = false;
      }
    licenceExpire() {
        this.appServiceManager.get(`branches/${this.branch}/users/license-detail`).subscribe(
            (res: any) => {
                if (res) {
                    this.license = res;
                    if (res.isActive === false) {
                        this.licenseMessage = res.msg || res.message;
                        this.licencestate = "error";
                        return;
                    }
                    const oneDay = 24 * 60 * 60 * 1000;
                    let date: any = new Date(this.license.expiryDate).valueOf() - new Date().valueOf();
                    const diffDays = Math.round(Math.abs((date) / oneDay));
                    this.license.expiryDate = this.datePipe.transform(this.license.expiryDate, 'fullDate');
                    this.licenseMessage = `License is valid till ${this.license.expiryDate} (${diffDays} days remaining)`;
                    if (diffDays <= 5) {
                        this.licencestate = "error";
                    } else if (diffDays < 10) {
                        this.licencestate = "warn";
                    } else {
                        this.licencestate = "success";
                    }
                }
            },
            (error) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: error,
                });
            }
        );
    }

}


